<template>
  <!-- Dải thông báo "đang dùng bản cũ — chuyển sang bản mới".
       Đối xứng với LegacyVersionBar bên bản mới (React): bản cũ (Vue) và bản
       mới (/v2/) chạy song song, người dùng phải thấy ngay lối chuyển sang bản
       mới, không phải đi hỏi.
       Ba điều kiện để dải không gây phiền:
         · cao 32px, một dòng chữ + một liên kết — không ăn chỗ của nội dung;
         · tắt được, nhớ theo TỪNG NGƯỜI (một máy nhiều tài khoản thì mỗi người
           một lựa chọn);
         · tắt rồi là thôi hẳn, không mọc lại ở lần tải sau.
       Khai chiều cao ra biến --sw-topbar-h để vùng nội dung (el-main) trừ đúng
       ngần ấy — nếu không, trang dài hơn màn hình đúng 32px và mọi màn mọc thanh
       cuộn dọc. -->
  <div v-if="hien" data-newver-bar class="newver-bar">
    <span class="newver-text">
      Bạn đang sử dụng phiên bản cũ của <b>Salework Contact</b>.
    </span>
    <!-- Mở NGAY TRONG TAB hiện tại: người bấm là muốn chuyển hẳn sang bản mới,
         mở tab mới thì họ có hai bản chạy song song và dễ nhập liệu nhầm chỗ. -->
    <a :href="URL_BAN_MOI" class="newver-link">Chuyển sang phiên bản mới</a>

    <button
      type="button"
      class="newver-close"
      aria-label="Ẩn thông báo"
      title="Ẩn thông báo"
      @click="tat"
    >
      <i class="el-icon-close"></i>
    </button>
  </div>
</template>

<script>
const URL_BAN_MOI = "https://contact.salework.net/v2/";
const KHOA = "sw-hide-newver-bar";
const CAO = 32; // px — khớp với chiều cao .newver-bar

export default {
  name: "NewVersionBar",
  data() {
    return {
      URL_BAN_MOI,
      hien: this.tinhHienBanDau(),
    };
  },
  computed: {
    khoaNguoiDung() {
      const u = this.app && this.app.user ? this.app.user : {};
      return `${u.id != null ? u.id : "guest"}_${u.swUsername || ""}`;
    },
  },
  watch: {
    // Người dùng nạp sau khi verify() xong → tính lại theo đúng tài khoản.
    khoaNguoiDung() {
      this.hien = this.tinhHienBanDau();
      this.capNhatChieuCao();
    },
    hien() {
      this.capNhatChieuCao();
    },
  },
  mounted() {
    this.capNhatChieuCao();
  },
  beforeDestroy() {
    document.documentElement.style.setProperty("--sw-topbar-h", "0px");
  },
  methods: {
    tinhHienBanDau() {
      try {
        const daTat = JSON.parse(localStorage.getItem(KHOA) || "{}");
        return !daTat[this.khoaNguoiDung];
      } catch (e) {
        return true;
      }
    },
    // Vùng nội dung trừ đi đúng chiều cao dải (0px khi ẩn) để không sinh scroll.
    capNhatChieuCao() {
      document.documentElement.style.setProperty(
        "--sw-topbar-h",
        this.hien ? `${CAO}px` : "0px"
      );
    },
    tat() {
      this.hien = false;
      try {
        const daTat = JSON.parse(localStorage.getItem(KHOA) || "{}");
        daTat[this.khoaNguoiDung] = true;
        localStorage.setItem(KHOA, JSON.stringify(daTat));
      } catch (e) {
        /* localStorage bị chặn — vẫn ẩn cho phiên này */
      }
    },
  },
};
</script>

<style scoped>
.newver-bar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  flex-shrink: 0;
  padding: 0 40px;
  background: #eff6ff;
  border-bottom: 1px solid #dbe6fb;
  font-size: 13px;
  color: #334155;
}
.newver-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.newver-text b {
  font-weight: 600;
}
.newver-link {
  flex-shrink: 0;
  font-weight: 600;
  color: #1769d7;
  text-decoration: none;
}
.newver-link:hover {
  text-decoration: underline;
}
.newver-close {
  position: absolute;
  right: 8px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  border-radius: 6px;
  color: #64748b;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.newver-close:hover {
  background: #dbe6fb;
  color: #334155;
}
</style>
